import * as React from 'react'

import { observer } from 'mobx-react'

import { ResetIcon } from '~/client/src/shared/components/icons/ResetIcon'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

interface IProps {
  onReset: () => void
}

@observer
export default class FilterResetter extends React.PureComponent<IProps> {
  public render() {
    const { onReset } = this.props

    return (
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={onReset}
        title={Localization.translator.resetFilters}
      >
        <ResetIcon size="xs" />
      </Button>
    )
  }
}
